import { useCallback } from 'react'
import toast from 'react-hot-toast'

import { resetComponentsSettings } from 'src/redux/actions/componentsSettingsActions'
import { useAppSelector } from 'src/redux/hooks'
import useDashboardsService from 'src/services/dashboardService'
import useSelectedDashboardStore from 'src/stores/useSelectedDashboardStore'
import useDispatcher from './useDispatcher'
import useGetDashboardPayload from './useGetDashboardPayload'
import useHasChangeOnPage from './useHasChangeOnPage'

const useUpdateDashboard = () => {
  const { updateDashboard } = useDashboardsService()
  const settings = useAppSelector(s => s.componentsSettings.settings)

  const resetComponentsSettingsDispatcher = useDispatcher(resetComponentsSettings)

  const { handleGetSaveDashboardPayloadData } = useGetDashboardPayload()

  const { setHasChangesOnDashboard } = useHasChangeOnPage()

  const selectedDashboard = useSelectedDashboardStore(s => s.selectedDashboard)

  const handleUpdateDashboard = useCallback(() => {
    if (!selectedDashboard?.id) return
    const payload = handleGetSaveDashboardPayloadData(selectedDashboard.name)
    const { id, name } = selectedDashboard
    toast
      .promise(
        updateDashboard(id, payload),
        {
          loading: 'Please wait...',
          success: (
            <span>
              <b>{name}</b> dashboard successfully saved
            </span>
          ),
          error: 'An error occurred. Please retry.',
        },
        { duration: 4000 },
      )
      .then(() => {
        resetComponentsSettingsDispatcher(settings, settings)
        setHasChangesOnDashboard(false)
      })
  }, [
    handleGetSaveDashboardPayloadData,
    resetComponentsSettingsDispatcher,
    setHasChangesOnDashboard,
    updateDashboard,
    selectedDashboard,
  ])

  return { handleUpdateDashboard }
}

export default useUpdateDashboard
